import { render, staticRenderFns } from "./BusinessMemberPlanActivation.vue?vue&type=template&id=4fa370fc"
import script from "./BusinessMemberPlanActivation.vue?vue&type=script&lang=js"
export * from "./BusinessMemberPlanActivation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports